import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Modal } from "react-bootstrap";
import SelectDropDown from '../selectdropdown/SelectDropDown'
import CardLessDataTableWithOutSearch from '../datatables/CardLessDataTableWithOutSearch';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { components } from 'react-select'
import moment, { invalid } from "moment";
import axios, { post } from "axios";
import MultiSelect from "react-multi-select-component";
import TextEditor from '../text_editor/TextEditor';
import { log } from 'logrocket';

const ADD_PARENT_CUSTOM_NOTIFICATION = gql`
  mutation($params:SendParentCustomNotification){
        sendParentCustomNotification(
        params: $params
    )}`;
const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};
class ParentNotificationModal extends Component {
    constructor(props) {
        super();
        const now = new Date();
        const year = now.getFullYear();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString().padStart(2, '0');
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const currentDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;

        this.state = {
            branch: "",
            branchSearch: "0",
            branchSearchval: "",
            exam: "",
            getExamArr: [],
            examError: "",
            examSelectedvalue: [],
            class: "",
            classError: "",
            getClassArr: [],
            classSelectedvalue: [],
            section: "",
            sectionError: "",
            getSectionArr: [],
            sectionSelectedvalue: [],
            studentsOptions: [],
            selectedStudents: [],
            students_error: "",
            branchWiseData: [],
            examWiseStudentData: [],
            classWiseStudentData: [],
            sectionWiseStudentData: [],
            title: "",
            title_error: "",
            subTitle: "",
            subTitle_error: "",
            schedule_time: currentDateTime,
            ldescription: "",
            ldescription_error: "",
            loader: 0,
            submitError: "",
            submitted: false
        }
    }

    componentDidMount() {

        let branchData = this.props.globals.globalBranches;

        let getExamArr = [];
        let getClassArr = [];
        let getSectionArr = [];

        if (branchData.length > 0) {
            // Exams selection
            let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id).map((item1) => item1.exam_id))].sort();

            uniqueExams.map((val) => {
                let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                const newObj = {
                    value: individualExamData.id,
                    label: individualExamData.exam
                }
                getExamArr.push(newObj);
            });

            //Class selection

            let selectedExamsValues = getExamArr.map((item) => item.value);

            let uniqueClasses = [];

            if (selectedExamsValues.length > 0) {

                selectedExamsValues.map((val) => {
                    let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
                    console.log("individualClassValues", individualClassValues);
                    uniqueClasses.push(...individualClassValues)
                });
            }

            if (uniqueClasses.length > 0) {
                [...new Set(uniqueClasses)].map((val) => {
                    let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getClassArr.push(newObj);
                });

                let selectedClasses = getClassArr.map((item) => item.value);


                //section selection

                let uniqueSections = [];

                if (selectedClasses.length > 0) {
                    selectedExamsValues.map((val) => {
                        selectedClasses.map((val1) => {
                            let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                            if (individualsectionValues.length > 0) {
                                uniqueSections.push(...individualsectionValues)
                            }
                        })
                    });
                }

                if (uniqueSections.length > 0) {
                    [...new Set(uniqueSections)].map((val) => {
                        let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualSectionData.id,
                            label: individualSectionData.section_name
                        }
                        getSectionArr.push(newObj);
                    });
                }
            }

            let studentsArray = [];
            let branchWiseData = [];

            let StudentsData = this.props.getNewEducationalStudents;

            if (StudentsData.length > 0) {
                let StudentsFilterData = StudentsData.filter((a) => a.branch_id == branchData[0].id);
                StudentsFilterData.map((item) => {
                    const newObj = {
                        value: item.student_id,
                        label: `${item.roll_no} => ${item.student_name}`,
                        parent_mobile: item.parent_mobile
                    }
                    studentsArray.push(newObj)
                    branchWiseData.push({ ...item })
                })
            }

            this.setState({
                branchSearchval: {
                    value: branchData[0].id,
                    label: branchData[0].branch_name
                },
                branch: branchData[0].branch_name,
                branchSearch: branchData[0].id,
                getExamArr: getExamArr,
                examSelectedvalue: getExamArr,
                getClassArr: getClassArr,
                classSelectedvalue: getClassArr,
                getSectionArr: getSectionArr,
                sectionSelectedvalue: getSectionArr,
                studentsOptions: studentsArray,
                selectedStudents: studentsArray,
                branchWiseData: branchWiseData,
                examWiseStudentData: branchWiseData,
                classWiseStudentData: branchWiseData,
                sectionWiseStudentData: branchWiseData,
            });
        }
    }

    handleMultipleSelectInputChange = (e, name) => {

        console.log("multipleChange", e, name);


        if (name == "class") {

            let classSelectedvalue = [];
            let getSectionArr = [];

            if (e.length > 0) {
                for (let i = 0; i < e.length; i++) {
                    const classval = e[i];
                    const newObj = {
                        label: classval.label,
                        value: classval.value,
                    }
                    classSelectedvalue.push(newObj);
                }

                let selectedExamsValues = this.state.examSelectedvalue.map((item) => item.value);
                let selectedClasses = classSelectedvalue.map((item) => item.value);
                let uniqueSections = [];

                if (selectedClasses.length > 0) {
                    selectedExamsValues.map((val) => {
                        selectedClasses.map((val1) => {
                            let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                            if (individualsectionValues.length > 0) {
                                uniqueSections.push(...individualsectionValues)
                            }
                        })
                    });
                }

                if (uniqueSections.length > 0) {
                    [...new Set(uniqueSections)].map((val) => {
                        let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualSectionData.id,
                            label: individualSectionData.section_name
                        }
                        getSectionArr.push(newObj);
                    });
                }


                let examWiseStudentData = this.state.examWiseStudentData;

                console.log("examWiseData", examWiseStudentData);

                let studentsArray = [];
                let classWiseData = [];


                if (examWiseStudentData.length > 0) {
                    console.log("eeeeee", e);
                    e.map((class_id) => {
                        let data = examWiseStudentData.filter((student) => student.class_id == class_id.value);
                        classWiseData.push(...data)
                    });

                    classWiseData.map((item) => {
                        const newObj = {
                            value: item.student_id,
                            label: `${item.roll_no} => ${item.student_name}`,
                            parent_mobile: item.parent_mobile
                        }
                        studentsArray.push(newObj);
                    });
                }



                this.setState({
                    classSelectedvalue: classSelectedvalue,
                    classError: "",
                    getSectionArr: getSectionArr,
                    sectionSelectedvalue: getSectionArr,
                    studentsOptions: studentsArray,
                    selectedStudents: studentsArray,
                    classWiseStudentData: classWiseData,
                    sectionWiseStudentData: classWiseData,
                });
            } else {
                this.setState({
                    classSelectedvalue: classSelectedvalue,
                    classError: "",
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                    studentsOptions: [],
                    selectedStudents: [],
                });
            }
        }

        if (name == "exam") {
            let examSelectedvalue = [];

            if (e.length > 0) {

                for (let i = 0; i < e.length; i++) {
                    const examval = e[i];
                    const newObj = {
                        label: examval.label,
                        value: examval.value,
                    }
                    examSelectedvalue.push(newObj);
                }


                let selectedExamsValues = examSelectedvalue.map((item) => item.value);

                let uniqueClasses = [];
                let getClassArr = [];
                let getSectionArr = [];


                if (selectedExamsValues.length > 0) {

                    selectedExamsValues.map((val) => {
                        let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
                        console.log("individualClassValues", individualClassValues);
                        uniqueClasses.push(...individualClassValues)
                    });
                }



                if (uniqueClasses.length > 0) {
                    [...new Set(uniqueClasses)].map((val) => {

                        console.log("uniqueClasses", val);

                        let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualClassData.id,
                            label: individualClassData.class
                        }
                        getClassArr.push(newObj);
                    });

                    let selectedClasses = getClassArr.map((item) => item.value);


                    //section selection

                    let uniqueSections = [];

                    if (selectedClasses.length > 0) {
                        selectedExamsValues.map((val) => {
                            selectedClasses.map((val1) => {
                                let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                                if (individualsectionValues.length > 0) {
                                    uniqueSections.push(...individualsectionValues)
                                }
                            })
                        });
                    }

                    if (uniqueSections.length > 0) {
                        [...new Set(uniqueSections)].map((val) => {
                            let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                            const newObj = {
                                value: individualSectionData.id,
                                label: individualSectionData.section_name
                            }
                            getSectionArr.push(newObj);
                        });
                    }
                }




                let branchWiseData = this.state.branchWiseData;

                let studentsArray = [];
                let examWiseData = [];


                if (branchWiseData.length > 0) {
                    e.map((exam) => {
                        let data = branchWiseData.filter((student) => student.exam_id == exam.value);
                        examWiseData.push(...data)
                    });

                    examWiseData.map((item) => {
                        const newObj = {
                            value: item.student_id,
                            label: `${item.roll_no} => ${item.student_name}`,
                            parent_mobile: item.parent_mobile
                        }
                        studentsArray.push(newObj);
                    });
                }



                this.setState({
                    examSelectedvalue: examSelectedvalue,
                    examError: "",
                    getClassArr: getClassArr,
                    classSelectedvalue: getClassArr,
                    getSectionArr: getSectionArr,
                    sectionSelectedvalue: getSectionArr,
                    studentsOptions: studentsArray,
                    selectedStudents: studentsArray,
                    examWiseStudentData: examWiseData,
                    classWiseStudentData: examWiseData,
                    sectionWiseStudentData: examWiseData,


                });
            } else {
                this.setState({
                    examSelectedvalue: [],
                    getClassArr: [],
                    classSelectedvalue: [],
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                    studentsOptions: [],
                    selectedStudents: [],

                });
            }
        }

        if (name == "section") {

            let sectionSelectedvalue = [];

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const sectionval = e[i];
                    const newObj = {
                        label: sectionval.label,
                        value: sectionval.value,
                    }
                    sectionSelectedvalue.push(newObj);
                }


                let classWiseStudentData = this.state.classWiseStudentData;

                console.log("examWiseData", classWiseStudentData);

                let studentsArray = [];
                let sectionWiseStudentData = [];


                if (classWiseStudentData.length > 0) {
                    console.log("eeeeee", e);
                    e.map((section) => {
                        let data = classWiseStudentData.filter((student) => student.section_id == section.value);
                        sectionWiseStudentData.push(...data)
                    });

                    sectionWiseStudentData.map((item) => {
                        const newObj = {
                            value: item.student_id,
                            label: `${item.roll_no} => ${item.student_name}`,
                            parent_mobile: item.parent_mobile
                        }
                        studentsArray.push(newObj);
                    });
                }



                this.setState({
                    sectionSelectedvalue: sectionSelectedvalue,
                    sectionError: "",
                    studentsOptions: studentsArray,
                    selectedStudents: studentsArray,
                    sectionWiseStudentData: sectionWiseStudentData,
                });
            } else {
                this.setState({
                    sectionSelectedvalue: [],
                    sectionError: "",
                    studentsOptions: [],
                    selectedStudents: [],
                });
            }
        }

        if (name == "student") {
            // let studenttopic = Array();
            let studenttopicvalue = Array();

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const stuval = e[i];
                    const newObj = {
                        label: stuval.label,
                        value: stuval.value,
                        parent_mobile:stuval.parent_mobile
                    }
                    studenttopicvalue.push(newObj);
                    // studenttopic.push(stuval.value);
                }
                this.setState({
                    selectedStudents: studenttopicvalue,
                    students_error: ""
                });
            }
        }
    }

    dropDownGetValues(fieldname) {
        let getArray = [];
        if (fieldname == "branchSearch") {
            this.props.globals.globalBranches.map((stumap) => {
                const newObj = {
                    value: stumap.id,
                    label: stumap.branch_name
                }
                getArray.push(newObj);
            });
        }
        return getArray;
    }

    selecthandleBranch = (name, value) => {

        if (name == "branchSearch") {
            if (value != "0") {
                let branchSearchData = this.props.globals.globalBranches.find((a) => a.id == value);
                console.log("branchSearchData", branchSearchData);

                let getExamArr = [];
                let getClassArr = [];
                let getSectionArr = [];

                if (branchSearchData != null) {
                    // Exams selection
                    let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData.id).map((item1) => item1.exam_id))].sort();

                    uniqueExams.map((val) => {
                        let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualExamData.id,
                            label: individualExamData.exam
                        }
                        getExamArr.push(newObj);
                    });

                    //Class selection

                    let selectedExamsValues = getExamArr.map((item) => item.value);

                    let uniqueClasses = [];

                    if (selectedExamsValues.length > 0) {

                        selectedExamsValues.map((val) => {
                            let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData.id && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
                            uniqueClasses.push(...individualClassValues)
                        });
                    }

                    if (uniqueClasses.length > 0) {
                        [...new Set(uniqueClasses)].map((val) => {
                            let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                            const newObj = {
                                value: individualClassData.id,
                                label: individualClassData.class
                            }
                            getClassArr.push(newObj);
                        });

                        let selectedClasses = getClassArr.map((item) => item.value);


                        //section selection

                        let uniqueSections = [];

                        if (selectedClasses.length > 0) {
                            selectedExamsValues.map((val) => {
                                selectedClasses.map((val1) => {
                                    let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData.id && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                                    if (individualsectionValues.length > 0) {
                                        uniqueSections.push(...individualsectionValues)
                                    }
                                })
                            });
                        }

                        if (uniqueSections.length > 0) {
                            [...new Set(uniqueSections)].map((val) => {
                                let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                                const newObj = {
                                    value: individualSectionData.id,
                                    label: individualSectionData.section_name
                                }
                                getSectionArr.push(newObj);
                            });
                        }
                    }

                    let studentsArray = [];
                    let branchWiseData = [];

                    let StudentsData = this.props.getNewEducationalStudents;

                    if (StudentsData.length > 0) {
                        let StudentsFilterData = StudentsData.filter((a) => a.branch_id == value);
                        StudentsFilterData.map((item) => {
                            const newObj = {
                                value: item.student_id,
                                label: `${item.roll_no} => ${item.student_name}`,
                                parent_mobile: item.parent_mobile
                            }
                            studentsArray.push(newObj);
                            branchWiseData.push({ ...item })
                        })
                    }



                    this.setState({
                        branchSearchval: {
                            value: branchSearchData.id,
                            label: branchSearchData.branch_name
                        },
                        branch: branchSearchData.branch_name,
                        branchError: "",
                        selectedStudents: [],
                        title: "",
                        subTitle: "",
                        getExamArr: getExamArr,
                        examSelectedvalue: getExamArr,
                        getClassArr: getClassArr,
                        classSelectedvalue: getClassArr,
                        getSectionArr: getSectionArr,
                        sectionSelectedvalue: getSectionArr,
                        studentsOptions: studentsArray,
                        selectedStudents: studentsArray,
                        branchWiseData: branchWiseData,
                        examWiseStudentData: branchWiseData,
                        classWiseStudentData: branchWiseData,
                        sectionWiseStudentData: branchWiseData,
                    });
                }

            }
        }

        this.setState({ [name]: value });
    }

    handleFormChange = (e) => {
        let name = e.target.name
        let value = e.target.value

        if (name == "title") {
            this.setState({ title: value, title_error: "" })
        }
        if (name == "subTitle") {
            this.setState({ subTitle: value, subTitle_error: "" })
        }
        if (name == "schedule_time") {
            this.setState({ schedule_time: value })
        }
        //    if (name == "image") {
        //         var file = e.target.files[0];
        //         let fileread = new FileReader();
        //         this.setState({
        //             image_filename: "Uploading...",
        //         });

        //         fileread.readAsDataURL(file);
        //         fileread.onload = async (e) => {
        //             console.log("Target", e.target);

        //             let fobj = {
        //                 stream: e.target.result,
        //                 filename: file.name,
        //                 mimetype: file.type,
        //             };

        //             const upload = await this.fileUpload(file, fobj.stream);
        //             console.log("file uploaded", upload);

        //             if (upload.data.result == "success") {
        //                 this.setState({ image: upload.data.filename, image_error:"" });

        //                 this.setState({
        //                     image_filename: file.name,
        //                 });
        //             }
        //         };

        //     }
    }

    handleEditorChange = (e) => {
        console.log("handleEditorChange", e.target.getContent());
        this.setState({
            ldescription: e.target.getContent(),
            ldescription_error: ""
        })
        // , () => {
        //     this.validateField("ldescription", "1");
        // });

    }

    handleFormSubmit = e => {
         e.preventDefault();
        if (!this.state.examSelectedvalue.length) {
            this.setState({ examError: "Please select exam" });
            return ""
        }

        if (!this.state.classSelectedvalue.length) {
            this.setState({ classError: "Please select class" });
            return ""
        }

        if (!this.state.sectionSelectedvalue.length) {
            this.setState({ sectionError: "Please select section" });
            return ""
        }
        if (!this.state.selectedStudents.length) {
            this.setState({ students_error: "Please select students" });
            return ""
        }

        if (this.state.title == "") {
            this.setState({ title_error: "Please enter title", })
            return ""
        }
        if (this.state.subTitle == "") {
            this.setState({ subTitle_error: "Please enter message", })
            return ""
        }
        // if (this.state.image == "") {
        //     this.setState({ image_error: "Please choose file", })
        //     return ""
        // }
        if (this.state.ldescription == "") {
            this.setState({ ldescription_error: "Please enter description", })
            return ""
        }

        const params = {
            branch_id: this.state.branchSearch,
            institute_id: parseInt(Cookies.get("institutionid")),
            class_id: this.state.classSelectedvalue.map((item) => item.value).toString(),
            section_id: this.state.sectionSelectedvalue.map((sectionid) => sectionid.value).toString(),
            notification_title: this.state.title,
            notification_subtitle: this.state.subTitle,
            long_description: this.state.ldescription,
            schedule_time: moment(this.state.schedule_time).unix().toString(),
            parent_mobile: this.state.selectedStudents.filter((a) => a.parent_mobile != null).map((i) => i.parent_mobile).toString(),
            exam_id: this.state.examSelectedvalue.map((examid) => examid.value).toString()
        }

        this.setState({
            loader: 1
        });

        this.addParentCustomNotification(
            params
        ).catch(error => {
            console.log("catch if error");
            console.log("params", params);
            console.log(error);


            this.setState({
                submitError: error.graphQLErrors.map(x => x.message),
                loader: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });

        setTimeout(() => {
            this.SetpageLoad();
        }, 3000);

    }

    addParentCustomNotification = async (
        params) => {
        await this.props.addParentCustomNotification({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.sendParentCustomNotification) {
                    this.setState({
                        loader: 0,
                        submitted: true
                    })
                }
            }

        });

    };

    SetpageLoad = () => {
        this.setState({ submitted: false, submitError: "", loading: 0 });
        window.location.reload(false);
    };
    render() {
        console.log("state", this.state);
        let examselectall = true;
        let examlabelledBy = "Select";
        let examdisableSearch = false;

        let classselectall = true;
        let classlabelledBy = "Select";
        let classdisableSearch = false;

        let sectionselectall = true;
        let sectionlabelledBy = "Select";
        let sectiondisableSearch = false;

        let studentselectall = true;
        let studentlabelledBy = "Select";
        let studentdisablesearch = false;

        if (this.props.globals.classes.length > 0) {
            classselectall = true;
            classdisableSearch = false;
        }
        else {
            classdisableSearch = true;
            classselectall = false;
            classlabelledBy = "Class"
        }

        if (this.props.globals.exams.length > 0) {
            examselectall = true;
            examdisableSearch = false;
        }
        else {
            examdisableSearch = true;
            examselectall = false;
            examlabelledBy = "Exam"
        }

        if (this.props.globals.globalSections.length > 0) {
            sectionselectall = true;
            sectiondisableSearch = false;
        }
        else {
            sectiondisableSearch = true;
            sectionselectall = false;
            sectionlabelledBy = "Section"
        }

        if (this.state.studentsOptions.length > 0) {
            studentselectall = true;
            studentdisablesearch = false;
        }
        else {
            studentdisablesearch = true;
            studentselectall = false;
            studentlabelledBy = "student"
        }
         return (
            <Card>
                <Card.Body>
                    <Form>
                        <Form.Row>
                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectBranch">
                                <Form.Label className="text-uppercase font-weight-bold">Branch</Form.Label>
                                <SelectDropDown
                                    stateData={this.state.branchSearchval}
                                    handleChange={this.selecthandleBranch}
                                    name="branchSearch"
                                    options={this.dropDownGetValues("branchSearch")}
                                    placeholderName={'Branch'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                />
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectExam">
                                <Form.Label className="text-uppercase font-weight-bold">Exam</Form.Label>
                                <MultiSelect
                                    overrideStrings={{
                                        "allItemsAreSelected": "All Exams are selected.",
                                        "selectSomeItems": examlabelledBy
                                    }}
                                    disableSearch={examdisableSearch}
                                    hasSelectAll={examselectall}
                                    options={this.state.getExamArr}
                                    value={this.state.examSelectedvalue}
                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "exam")}
                                    labelledBy={"exam"}
                                />
                                <Form.Text className="form-text text-danger">{this.state.examError}</Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectClass">
                                <Form.Label className="text-uppercase font-weight-bold">Class</Form.Label>
                                <MultiSelect
                                    overrideStrings={{
                                        "allItemsAreSelected": "All Classes are selected.",
                                        "selectSomeItems": classlabelledBy
                                    }}
                                    disableSearch={classdisableSearch}
                                    hasSelectAll={classselectall}
                                    options={this.state.getClassArr}
                                    value={this.state.classSelectedvalue}
                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "class")}
                                    labelledBy={"class"}
                                />
                                <Form.Text className="form-text text-danger">{this.state.classError}</Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectSection">
                                <Form.Label className="text-uppercase font-weight-bold">Section</Form.Label>
                                <MultiSelect
                                    overrideStrings={{
                                        "allItemsAreSelected": "All Sections are selected.",
                                        "selectSomeItems": sectionlabelledBy
                                    }}
                                    disableSearch={sectiondisableSearch}
                                    hasSelectAll={sectionselectall}
                                    options={this.state.getSectionArr}
                                    value={this.state.sectionSelectedvalue}
                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "section")}
                                    labelledBy={"section"}
                                />
                                <Form.Text className="form-text text-danger"> {this.state.sectionError}</Form.Text>

                            </Form.Group>
                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectStudent">
                                <Form.Label className="text-uppercase font-weight-bold">Students</Form.Label>
                                <MultiSelect
                                    overrideStrings={{
                                        "allItemsAreSelected": "All Students are selected.",
                                        "selectSomeItems": studentlabelledBy
                                    }}
                                    disableSearch={studentdisablesearch}
                                    hasSelectAll={studentselectall}
                                    options={this.state.studentsOptions}
                                    value={this.state.selectedStudents}
                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "student")}
                                    labelledBy={"student"}
                                />
                                <Form.Text className="form-text text-danger">{this.state.students_error}</Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12}>
                                <Form.Label className="text-uppercase font-weight-bold">Notification Title</Form.Label>
                                <Form.Control placeholder='Enter Title' name='title' onChange={this.handleFormChange} value={this.state.title}></Form.Control>
                                <Form.Text className="form-text text-danger">{this.state.title_error}</Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12}>
                                <Form.Label className="text-uppercase font-weight-bold">Notification Subtitle</Form.Label> <br />
                                <Form.Control as="textarea" rows="2" type="text" placeholder="Enter subTitle" name="subTitle" onChange={this.handleFormChange} value={this.state.message} />
                                <Form.Text className="form-text text-danger">{this.state.subTitle_error}</Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12}>
                                <Form.Label className="text-uppercase font-weight-bold">Schedule Time</Form.Label> <br />
                                <Form.Control type="datetime-local" name="schedule_time" onChange={this.handleFormChange} value={this.state.schedule_time} />
                            </Form.Group>
 
                            <Form.Group as={Col} lg={12} md={12} sm={12}>
                                <Form.Label className="text-uppercase font-weight-bold">Long Description</Form.Label>
                                <TextEditor handleEditorChange={this.handleEditorChange} value={this.state.ldescription} />
                                <Form.Text className="form-text text-danger"> {this.state.ldescription_error} </Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={4} md={12} sm={12} controlId="formLong">
                                <button className="btn px-5" onClick={this.handleFormSubmit} style={{backgroundColor:"#213046",color:"#fff",fontSize:"12px",padding:"7px"}}>
                                    {
                                        this.state.loader == 1 ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : ""
                                    }Send Notification</button>
                                <div>
                                    {
                                        this.state.submitted == true ? (
                                            <p className="text-success mt-1" >Notification send Successfully </p>
                                        ) : ""
                                    }
                                    {
                                        this.state.periodError != "" ? (
                                            <span className="text-danger mt-1">{this.state.submitError}</span>
                                        ) : ("")
                                    }
                                </div>
                            </Form.Group>
                        </Form.Row>
                    </Form>
                </Card.Body>
            </Card>
        )
    }
}
export default graphql(ADD_PARENT_CUSTOM_NOTIFICATION, {
    name: "addParentCustomNotification"
})(ParentNotificationModal);
// NARESH